<template>
  <helper-layout :loaded="mx_loaded">
    <div class="filterWrap">
      <div
        v-for="(filter, index) in FilterItem"
        :key="index"
        class="filterDiv"
        :style="
          `color:${form.state == filter.id ? '#fff' : ''};background:${
            form.state === filter.id ? colorMap[color] : ''
          }`
        "
        @click="clickFilter(filter.id)"
      >
        {{ filter.name }}(
        <span :class="form.state == filter.id ? '' : 'redFont'">{{
          intData[filter.count]
        }}</span>
        )
      </div>
      <div class="refreshIcon">
        <v-icon :class="refreshloading ? 'active' : ''" @click.stop="refresh">
          mdi-autorenew
        </v-icon>
      </div>
    </div>
    <material-table
      :search-data="searchData"
      :headers="headers"
      :items="orderListData.orderList && orderListData.orderList.items"
      :paginate="paginateConfig"
      :total-count="
        orderListData.orderList && orderListData.orderList.totalCount
      "
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
    >
      <!-- <template v-slot:toolbar>
        <v-flex shrink style="text-align: right;" class="toolbar">
          <v-btn solid @click="exportFile">
            导出
            {{ $t("Views.Order.export") }}
          </v-btn>
        </v-flex>
      </template> -->
    </material-table>
    <material-dialog
      :width="modalType === 'del' ? 400 : 600"
      :visible="showModal"
      :title="modalTitle"
      @cancleFn="cancelDialog"
      @confirmFn="confirmDialog"
    >
      <template>
        <div v-if="modalType === 'del'">
          <span class="desc">{{ modalWaring }}</span>
        </div>
        <div v-else>
          <span class="desc">{{ modalWaring }}</span>
          <v-form ref="form" v-model="cancelFormValid">
            <v-layout row>
              <v-flex>
                <v-textarea
                  v-model="confirmMemo"
                  class="input-required"
                  :rules="[v => !!v || $t('Views.Order.memoNotEmpty'),
                           v => !!v.trim() || $t('Views.Order.memoNotEmpty')]"
                  required
                  counter
                  maxlength="50"
                  name="input-7-1"
                  :label="$t('Views.Order.memoNotEmpty')"
                />
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </template>
    </material-dialog>
  </helper-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import theme from '@/plugins/theme'
import { format } from 'date-fns'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      colorMap: theme,
      cancelFormValid: true,
      showModal: false,
      modalWaring: '',
      modalTitle: '',
      modalType: '',
      staffId: '',
      // 表格header栏配置
      headers: [
        {
          width: 150,
          align: 'left',
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.orderNum') + '<br/>' + $t('Views.Order.commitTime')
                }
              }
            )
          },
          render: (h, param) => {
            return h(
              'div',
              {
                props: {
                },
                domProps: {
                  innerHTML: `${param.row.number}<br/>${format(param.row.creationTime, 'YYYY-MM-DD')} `
                }
              }
            )
          }
        },
        // {
        //   text: $t('Views.Order.customerInfo'),
        //   width: 180,
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h(
        //       'div',
        //       {
        //         domProps: {
        //           innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.customerNum')
        //         }
        //       }
        //     )
        //   },
        //   render: (h, param) => {
        //     const text = param.row.customer ? param.row.customer.name + (param.row.customer.serialNumber ? '<br />' + param.row.customer.serialNumber : '') : '--'
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   }
        // },
        { // 新客户编码
          text: $t('Views.Order.newCustomerNumList'),
          width: 180,
          align: 'left',
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.newCustomerNumList')
                }
              }
            )
          },
          render: (h, param) => {
            const text = param.row.customer ? param.row.customer.name + (param.row.customer.newSerialNumber && param.row.customer.serialNumber ? '<br />' +
              param.row.customer.newSerialNumber : param.row.customer.newSerialNumber ? '<br />' + param.row.customer.newSerialNumber : '<br />' + param.row.customer.serialNumber) : '--'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          text: $t('Views.Finance.sales'), value: 'saleName', width: 120
        },
        // 仓库名称
        {
          text: $t('Views.Warehouse.warehouseName'), value: 'warehouseName', width: 120
        },
        {
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                style: {
                  textAlign: 'right',
                  display: 'block'
                },
                domProps: {
                  innerHTML: $t('Views.Order.settlementCurrency') + '<br/>' + $t('Views.Order.orderAmount')
                }
              }
            )
          },
          width: 130,
          render: (h, param) => {
            return h(
              'div',
              {
                style: {
                  textAlign: 'right',
                  display: 'block'
                },
                domProps: {
                  innerHTML: `${ENUMS.currencyName[param.row.currencyName]}<br/>${this.$util.data.moneyFmt(param.row.targetCurrencyOrderPrice, param.row.currencyName)} `
                }
              }
            )
          }
        },
        {
          text: $t('Views.Order.taxAmount'),
          sortable: false,
          align: 'right',
          value: 'targetCurrencyTaxRateAmount',
          width: 120,
          render: (h, params) => {
            return h('div',
              this.$util.data.moneyFmt(params.row.targetCurrencyTaxRateAmount, params.row.currencyName)
            )
          }
        },
        {
          text: $t('Views.Order.otherAmount'),
          align: 'right',
          value: 'targetCurrencyOtherPrice',
          width: 120,
          render: (h, params) => {
            return h('div',
              this.$util.data.moneyFmt(params.row.targetCurrencyOtherPrice, params.row.currencyName)
            )
          }
        },
        {
          text: $t('Views.Order.dueCharge'),
          sortable: false,
          align: 'right',
          width: 130,
          value: 'targetCurrencyPrice',
          render: (h, params) => {
            return h('div', this.$util.data.moneyFmt(params.row.targetCurrencyPrice, params.row.currencyName))
          }
        },
        {
          // 结算方式
          text: $t('Views.Customer.settlement'),
          sortable: false,
          align: 'left',
          width: 90,
          render: (h, params) => {
            return h('div', ENUMS.settlementType[params.row.settlementType] || '--')
          }
        },
        {
          // 状态
          text: $t('Views.Order.orderStatus'),
          value: 'status',
          width: 90,
          render: (h, params) => h(
            'div',
            {
              style: {
                color: ENUMS.orderStatus[params.row.state].color
              },
              class: 'status'
            },
            ENUMS.orderStatus[params.row.state].text
          )
        },
        {
          // 操作
          text: $t('Views.Setting.action'),
          value: 'action',
          width: 190,
          actions: [
            {
              // 查看
              text: $t('Views.Order.view'),
              color: this.$store.state.app.color,
              visible: true,
              actionFn: (param) => {
                this.$router.push({
                  name: 'orderDetails',
                  query: {
                    id: param.row.id
                  }
                })
              }
            },
            // {
            //   // 支付
            //   text: $t('Views.Customer.pay'),
            //   color: this.$store.state.app.payBtnColor,
            //   // 有“入金”权限并且“支付方式为月结且订单状态为“待发货”，“部分发货”，“已完成”状态的订单”
            //   // 【ID1000520】
            //   visible: (param) => this.$util.tool.hasPerm('OrderManager.OrderList.Payment') &&
            //   (
            //     (param.row.settlementType === 'PaymentMonthly' &&
            //   (param.row.state === 'Order' || param.row.state === 'PartialDelivery' || param.row.state === 'Finished')) ||
            //   (param.row.settlementType === 'PaymentNow' && param.row.state === 'PendingPayment')
            //   ),
            //   actionFn: (param) => {
            //     this.$router.push({
            //       name: 'orderDetails',
            //       query: {
            //         id: param.row.id,
            //         type: 'reCharge'
            //       }
            //     })
            //   }
            // },
            {
              // 审核
              text: $t('Views.Order.examine'),
              color: this.$store.state.app.payBtnColor,
              visible: (param) => param.row.state === 'Pending' && this.$util.tool.hasPerm('OrderManager.OrderList.Review'),
              actionFn: (param) => {
                this.$router.push({
                  name: 'orderDetails',
                  query: {
                    id: param.row.id,
                    type: param.row.state
                  }
                })
              }
            },
            {
              // 确认
              text: $t('Views.Order.confirm'),
              color: this.$store.state.app.payInfoBtnColor,
              visible: (param) => param.row.state === 'PendingConfirm' && this.$util.tool.hasPerm('OrderManager.OrderList.Confirm'),
              actionFn: (param) => {
                this.$router.push({
                  name: 'orderDetails',
                  query: {
                    id: param.row.id,
                    type: param.row.state
                  }
                })
              }
            },
            {
              // 取消
              text: $t('Views.Order.cancel'),
              color: this.$store.state.app.cancelBtnColor,
              visible: param => {
                return (param.row.state !== 'Finished' && param.row.state !== 'Canceled') && this.$util.tool.hasPerm('OrderManager.OrderList.Cancel')
              },
              actionFn: param => {
                this.$refs.form && (this.$refs.form).resetValidation()
                this.showModal = true
                this.modalTitle = this.$t('Views.Order.confirmCancel')
                param.row.state === 'PartialDelivery' ? this.modalType = 'deliverycancel' : this.modalType = 'cancel'
                this.modalType === 'cancel' ? this.modalWaring = this.$t('Views.Order.confirmCancelOrder') : this.modalWaring = this.$t('Views.Order.confirmDeliveryOrder')
                this.orderId = param.row.id
              }
            },
            {
              // 删除
              text: $t('Views.Order.del'),
              color: this.$store.state.app.banBtnColor,
              visible: param => {
                return param.row.state === 'Canceled' && this.$util.tool.hasPerm('OrderManager.OrderList.Delete')
              },
              actionFn: param => {
                this.showModal = true
                this.modalTitle = this.$t('Views.Order.deleteOrder')
                this.modalWaring = this.$t('Views.Order.sureOrder')
                this.modalType = 'del'
                this.orderId = param.row.id
              }
            }
          ]
        }
      ], // 表格数据检索配置
      searchData: [
        {
          key: 'settlementType',
          label: $t('Views.Customer.settlement'),
          value: '',
          placeholder: $t('Views.Customer.chooseSettleType'),
          type: 'select',
          state: [
            {
              value: '',
              label: $t('Views.Order.allItem')
            },
            {
              value: 'PrePayment',
              label: $t('Views.Order.prePayment')
            },
            {
              value: 'PaymentNow',
              label: $t('Views.Order.paymentNow')
            },
            {
              value: 'PaymentMonthly',
              label: $t('Views.Order.paymentMonthly')
            }
          ]
        },
        {
          key: 'customerFilter',
          label: $t('Views.Customer.customerInfo'),
          value: '',
          placeholder: $t('Views.Customer.customerNameOrSN')
        }, {
          key: 'salesId',
          value: '',
          type: 'select',
          name: $t('Views.Order.sale_label'),
          placeholder: $t('Core.System.pleaseSelect'),
          itemText: 'name',
          itemValue: 'id',
          state: []
        },
        {
          key: 'ProductCategoryId',
          id: '',
          // 分类
          label: $t('Views.Goods.categoryName'),
          value: '',
          type: 'cascader',
          placeholder: $t('Views.Order.allItem'),
          config: {
            label: 'name',
            value: 'id',
            children: 'items',
            checkStrictly: true
          },
          state: []
        },
        {
          key: 'dateRange',
          type: 'daterange',
          icon: 'mdi-calendar-range',
          label: $t('Views.Order.orderTime'),
          value: {}
        },
        {
          key: 'currency',
          label: $t('Views.Order.settlementCurrency'),
          value: '',
          placeholder: $t('Views.Order.allItem'),
          type: 'select',
          state: this.$util.tool.enumToSelect(ENUMS.currencyName)
        },
        {
          key: 'keyFilter',
          label: $t('Views.Order.keywords'),
          value: '',
          placeholder: $t('Views.Order.keywordsPlace')
        },
        {
          key: 'warehouseId',
          value: '',
          type: 'select',
          name: $t('Views.Order.warehouseInfo'),
          placeholder: $t('Core.System.pleaseSelect'),
          itemText: 'name',
          itemValue: 'id',
          state: []
        },
        {
          key: 'isMyToDo',
          value: true,
          label: $t('Views.Customer.myToDo'),
          type: 'checkbox',
          hidden: true
        }
      ], // 表格分页配置
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 表格搜索项
      FilterItem: [
        { name: $t('Views.Order.allItem'), id: '', count: 'totalCount' },
        { name: $t('Views.Order.beConfirmed'), id: 'PendingConfirm', count: 'pendingConfirmCount' },
        { name: $t('Views.Order.pending'), id: 'Pending', count: 'pendingCount' },
        { name: $t('Views.Order.pendingPayment'), id: 'PendingPayment', count: 'pendingPaymentCount' },
        { name: $t('Views.Order.shipped'), id: 'Order', count: 'orderCount' },
        { name: $t('Views.Order.partialDelivery'), id: 'PartialDelivery', count: 'partialDeliveryCount' },
        { name: $t('Views.Order.finished'), id: 'Finished', count: 'finishedCount' }
      ],
      confirmMemo: '', // 弹框备注
      confirmLoading: false,
      modalContent: '',
      modalIcon: '',
      modalApiType: '',
      orderId: '',
      form: {
        skipCount: 0,
        maxResultCount: 10
      },
      refreshloading: false,
      intData: {}
    }
  },
  computed: {
    ...mapState('order', ['orderListData']),
    ...mapState('goods', ['categoryList']),
    ...mapState('app', ['color']),
    ...mapState('setting', ['staffAllData']),
    ...mapState('login', ['userInfo']),
    ...mapState('warehouse', ['warehouseList'])
  },
  created() {
    if (this.$route.query.state) {
      this.form.state = this.$route.query.state
      this.$store.commit('order/setOrderState', this.$route.query.state)
    } else {
      this.form.state = this.$store.state.order.orderState || ''
    }
    this.salesSearch()
    this.warehouseSearch()
    this.showMyToDo()
    this.getPage()
    this.getCategory()
    this.getStaff()
  },
  methods: {
    ...mapActions('order', ['getOrderData', 'exportOrderList', 'delOrder', 'celOrder']),
    ...mapActions('goods', ['getCategoryList']),
    ...mapActions('setting', ['getStaffAllData']),
    ...mapActions('warehouse', ['getWarehousesList']),
    getCategory() {
      this.getCategoryList().then(() => {
        this.searchData[3].state = this.categoryList
      })
    },
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(() => {
        this.searchData[2].state = this.staffAllData.items
      })
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getOrderData(this.form).then(() => {
        this.paginateConfig.total = this.orderListData.orderList && this.orderListData.orderList.totalCount
        this.intData = {
          finishedCount: this.orderListData.finishedCount,
          orderCount: this.orderListData.orderCount,
          partialDeliveryCount: this.orderListData.partialDeliveryCount,
          pendingConfirmCount: this.orderListData.pendingConfirmCount,
          pendingCount: this.orderListData.pendingCount,
          totalCount: this.orderListData.totalCount,
          pendingPaymentCount: this.orderListData.pendingPaymentCount
        }
        this.form.state = this.$store.state.order.orderState || ''
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }
      if (search.dateRange) {
        this.form = { ...this.form, ...{ beginTime: search.dateRange.start }, ...{ endTime: search.dateRange.end }}
      }
      delete this.form.dateRange
      this.getPage(1)
    },
    refresh() {
      const searchData = {}
      this.searchData.map(item => {
        searchData[item.key] = item.value
      })
      this.refreshloading = true
      this.handleSearchChange(searchData)
      setTimeout(() => {
        this.refreshloading = false
      }, 500)
    },
    cancelDialog() {
      this.showModal = false
      this.confirmMemo = ''
    },
    confirmDialog() {
      if (this.modalType === 'del') {
        this.delOrder(this.orderId).then(() => {
          this.$store.commit('app/setNotification', {
            msg: this.$t('Views.Goods.actionSuccess'),
            type: 'success'
          })
          this.getPage()
        })
        this.showModal = false
      } else {
        this.$refs.form.validate()
        if (this.$refs.form.validate()) {
          this.celOrder({ id: this.orderId, remark: this.confirmMemo }).then(() => {
            this.$store.commit('app/setNotification', {
              msg: this.$t('Views.Goods.actionSuccess'),
              type: 'success'
            })
            this.getPage()
            this.confirmMemo = ''
          })
          this.showModal = false
        }
      }
    },
    clickFilter(id) {
      this.form.state = id
      this.$store.commit('order/setOrderState', this.form.state)
      this.paginateConfig.page = 1
      this.form.skipCount = 0
      this.salesSearch()
      this.showMyToDo()
      this.getPage()
    },
    exportFile() {
      this.exportOrderList(this.form).then(() => {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Goods.actionSuccess'),
          type: 'success'
        })
      }).catch(() => {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Order.exportError'),
          type: 'error'
        })
      })
    },
    showMyToDo() {
      // 待审核状态下的 系统管理员、部门管理才显示我的待办
      if (this.form.state === 'Pending' && (this.userInfo.isDepartmentManager || this.userInfo.isSuperAdmin)) {
        this.searchData[8].hidden = false
        this.searchData[8].value = true
        this.form.isMyToDo = true
      } else {
        this.searchData[8].hidden = true
        this.form.isMyToDo = false
      }
    },
    salesSearch() {
      // 待确认状态 赋值所属销售 其他状态清空销售
      if (this.form.state === 'PendingConfirm') {
        this.form.salesId = this.userInfo && this.userInfo.isSales ? this.userInfo.staffId : ''
        this.searchData[2].value = this.userInfo && this.userInfo.isSales ? this.userInfo.staffId : ''
      } else {
        this.searchData[2].value = ''
        this.form.salesId = ''
      }
    },
    warehouseSearch() {
      this.getWarehousesList({}).then(() => {
        this.searchData[7].state = this.warehouseList.items
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.filterWrap {
  display: flex;
  margin: 0 20px 20px 0px;
  overflow: auto;
}

.redFont {
  color: red;
}

.refreshIcon {
  margin-right:20px;
  .active {
    transform: rotate(360deg);
    transition: 0.1s;
  }
}

.filterDiv {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-weight: bold;
  color: #515151;
  padding: 4px 8px;
  background: #fff;
  margin-right: 8px;
  cursor: pointer;
  min-width: 130px;
  text-align: center;
}

.actived {
  background: #5cb85f;
  color: #fff;

  span {
    color: #fff;
  }
}
</style>
